<div id="user-management-view-list">
    <div class="user-list-filter">
        <div class="user-search-wrapper">
            <div class="user-search-block">
                <input type="text" class="user-search-input" name="search" [(ngModel)]="searchText" autocomplete="off">
                <button type="button"></button>
            </div>
        </div>
    </div>
    <div class="user-list">
        <ul>
        <ng-container class="user-each-loop" *ngFor="let user of users | filter:searchText" > 
            <li  (click)="onSelectUser(user)">
                <a [ngClass]="{ 'selected': user.usuarioId == selectedUser?.usuarioId }">
                    <span>{{user.nombre}}</span>
                    <span>{{user.abreviacion}}</span>
                </a>               
            </li>  
        </ng-container>    
        </ul>       
    </div>
    <div class="add-new-user">
        <button type="button" (click)="addNewUser()"><span>+</span></button>
    </div>
</div>
